var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 291,
    viewBox: "0 0 357 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.398 162.973H343.481C378.835 162.973 407.494 191.632 407.494 226.986C407.494 262.34 378.835 290.999 343.481 290.999H208.656C173.72 290.999 145.398 262.678 145.398 227.741V162.973Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.469 81.3988L343.483 81.3988L407.496 81.3988C407.496 116.752 378.836 145.412 343.483 145.412C308.129 145.412 279.469 116.752 279.469 81.3988Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.469 64.0133L343.483 64.0133L407.496 64.0133C407.496 28.6597 378.836 2.50551e-06 343.483 5.59622e-06C308.129 8.68693e-06 279.469 28.6598 279.469 64.0133Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00165355 226.797L64.015 226.797L128.028 226.797C128.028 262.151 99.3686 290.811 64.015 290.811C28.6614 290.811 0.00165045 262.151 0.00165355 226.797Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.425 139.369L209.412 139.369L145.398 139.369C145.398 104.015 174.058 75.3555 209.412 75.3555C244.765 75.3555 273.425 104.015 273.425 139.369Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeShapes);
export default __webpack_public_path__ + "static/media/WelcomeShapes.209c2cd63b27c9f722a1151ddc8af7d6.svg";
export { ForwardRef as ReactComponent };